import { render, staticRenderFns } from "./BaseConfirmDialog.vue?vue&type=template&id=22775838&scoped=true&"
import script from "./BaseConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./BaseConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfirmDialog.vue?vue&type=style&index=0&id=22775838&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22775838",
  null
  
)

export default component.exports